import {observer} from 'mobx-react-lite'
import {ToggleButton} from '@mui/material'
import {Typography, Tooltip} from '@mui/material'
import {getTypographyColor, OcToggleButtonProps} from './utils'

function _OcToggleButton(props: OcToggleButtonProps) {
    const {typoVariant, typoColor: _typoColor, children, tooltip, ...restProps} = props
    return (
        <Tooltip title={tooltip || ''}>
            <span>
                <ToggleButton {...restProps} color={props.color ?? 'primary'}>
                    <Typography variant={typoVariant ? typoVariant : 'body2'} color={getTypographyColor(props)}>
                        {children}
                    </Typography>
                </ToggleButton>
            </span>
        </Tooltip>
    )
}

export const OcToggleButton = observer(_OcToggleButton)
